/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
//#
// Extend Array prototype to include a #remove(element) method
//
// @author Philipp
Array.prototype.remove = function(element) {
  const index = this.indexOf(element);
  if (index > -1) { return this.splice(index, 1); }
};
